import {
	createStore
} from 'vuex'

export default createStore({
	state: {
		tagsList: [],
		collapse: false,
		username: "", //用户名
		password: "",
		address: "", //单位
		src: "", //头像
		role: "", //权限

		// website: "http://localhost:8001/Pc/",//公共路由
		// pcurl: "http://localhost:8001/Pc/",//公共路由
		// url:"http://localhost:8001/",
		// wx:"http://localhost:8001/WX/",

		pcurl: "http://api.tjfcs.cn/Pc/", //公共路由
		bigscreen: "http://api.tjfcs.cn/BigScreen/", //大屏路由
		url: "http://api.tjfcs.cn/",
		wx: "http://api.tjfcs.cn/WX/",
		website: "http://api.tjfcs.cn/WebSite/", //公共路由

		// website: "http://fcsapi.wenxingkeji.net/Pc/",//公共路由
		// pcurl: "http://fcsapi.wenxingkeji.net/Pc/",//公共路由
		// bigscreen:"http://localhost/BigScreen/",//大屏路由
		// url:"http://fcsapi.wenxingkeji.net/",
		// wx:"http://fcsapi.wenxingkeji.net/WX/",
		yulanList: []
	},
	mutations: {
		// initname (state, name) {
		//     state.username = name
		// },
		// initaddress (state, address) {
		//     state.address = address
		// },
		// initsrc (state, src) {
		//     state.src = src
		// },
		// initrole (state, role) {
		//     state.role = role
		// },
		delTagsItem(state, data) {
			state
				.tagsList
				.splice(data.index, 1);
		},
		setTagsItem(state, data) {
			state
				.tagsList
				.push(data)
		},
		clearTags(state) {
			state.tagsList = []
		},
		closeTagsOther(state, data) {
			state.tagsList = data;
		},
		closeCurrentTag(state, data) {
			for (let i = 0, len = state.tagsList.length; i < len; i++) {
				const item = state.tagsList[i];
				if (item.path === data.$route.fullPath) {
					if (i < len - 1) {
						data
							.$router
							.push(state.tagsList[i + 1].path);
					} else if (i > 0) {
						data
							.$router
							.push(state.tagsList[i - 1].path);
					} else {
						data
							.$router
							.push("/");
					}
					state
						.tagsList
						.splice(i, 1);
					break;
				}
			}
		},
		// 侧边栏折叠
		hadndleCollapse(state, data) {
			state.collapse = data;
		}
	},
	actions: {},
	modules: {}
})